export default "__VITE_ASSET__C48zikuL__"